<template>
  <svg
    width="511"
    height="511"
    viewBox="0 0 511 511"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :d="[
        'M503.5,476h-16.5v-209h16.5c2.74,0,5.26-1.49,6.58-3.89,1.32-2.4,1.22-5.33-.25-7.64',
        'l-56-88c-1.38-2.16-3.76-3.47-6.33-3.47h-148.89l-35.61-35.61v-29.39h72.5c2.77,0,5.31-1.52',
        ',6.61-3.96,1.3-2.44,1.16-5.4-.37-7.7l-13.23-19.84,13.23-19.84c1.54-2.3,1.68-5.26.37-7.7',
        '-1.31-2.44-3.85-3.96-6.61-3.96h-72.5v-8.5c0-4.14-3.36-7.5-7.5-7.5s-7.5,3.36-7.5,7.5v100.89',
        'l-35.61,35.61H63.5c-2.56,0-4.95,1.31-6.33,3.47L1.17,255.47c-1.47,2.31-1.56,5.24-.25,7.64',
        ',1.32,2.4,3.84,3.89,6.57,3.89h16.5v209H7.5c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5h496',
        'c4.14,0,7.5-3.36,7.5-7.5s-3.36-7.5-7.5-7.5ZM443.38,179l46.46,73h-103.23l-73-73h129.78',
        'ZM321.49,51l-8.23,12.34c-1.68,2.52-1.68,5.8,0,8.32l8.23,12.34h-58.49v-33h58.49',
        'ZM67.62,179h129.78l-73,73H21.16l46.45-73ZM39,267h88.5c.25,0,.5-.01.74-.04.11-.01.21-.03',
        '.32-.05.14-.02.27-.04.41-.06.12-.02.24-.06.36-.09.12-.03.24-.06.35-.09.12-.04.23-.08',
        '.35-.12.12-.04.23-.08.34-.13.11-.05.21-.1.32-.15.12-.05.23-.11.35-.17.1-.05.2-.12.3-.18',
        '.11-.07.22-.13.33-.2.11-.08.22-.16.32-.24.09-.07.18-.13.26-.2.19-.16.38-.32.55-.5',
        'l122.7-122.69,122.7,122.69c.17.17.36.34.55.5.08.07.17.13.26.2.11.08.21.17.33.24',
        '.11.07.22.13.33.2.1.06.2.12.3.18.11.06.23.11.34.17.11.05.21.1.32.15.11.05.23.08',
        '.34.12.12.04.23.09.35.12.11.04.23.06.35.09.12.03.24.07.37.09.13.03.27.04.4.06.11.02.22.04',
        '.33.05.25.02.49.04.74.04h88.5v209h-161v-104.5c0-12.96-10.54-23.5-23.5-23.5h-64',
        'c-12.96,0-23.5,10.54-23.5,23.5v104.5H39v-209ZM296,380h-81v-8.5c0-4.69,3.81-8.5,8.5-8.5h64',
        'c4.69,0,8.5,3.81,8.5,8.5v8.5ZM215,395h33v81h-33v-81ZM263,395h33v81h-33v-81Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M255.5,323c30.6,0,55.5-24.9,55.5-55.5s-24.9-55.5-55.5-55.5-55.5,24.9-55.5,55.5,24.9,55.5,',
        '55.5,55.5ZM255.5,227c22.33,0,40.5,18.17,40.5,40.5s-18.17,40.5-40.5,40.5-40.5-18.17-40.5-40.5,',
        '18.17-40.5,40.5-40.5Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M255.5,275c4.14,0,7.5-3.36,7.5-7.5v-24c0-4.14-3.36-7.5-7.5-7.5s-7.5,3.36-7.5,7.5v16.5h-16.5',
        'c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5h24Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M175.5,388h-40c-4.14,0-7.5,3.36-7.5,7.5v48c0,4.14,3.36,7.5,7.5,7.5h40c4.14,0,7.5-3.36,7.5-',
        '7.5v-48c0-4.14-3.36-7.5-7.5-7.5ZM168,403v9h-25v-9h25ZM143,436v-9h25v9h-25Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M103.5,388h-40c-4.14,0-7.5,3.36-7.5,7.5v48c0,4.14,3.36,7.5,7.5,7.5h40c4.14,0,7.5-3.36,7.5-',
        '7.5v-48c0-4.14-3.36-7.5-7.5-7.5ZM96,403v9h-25v-9h25ZM71,436v-9h25v9h-25Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M173,292h-35c-5.51,0-10,4.49-10,10v53.5c0,4.14,3.36,7.5,7.5,7.5h40c4.14,0,7.5-3.36,7.5-7.5',
        'v-53.5c0-5.51-4.49-10-10-10ZM168,307v17h-25v-17h25ZM143,348v-9h25v9h-25Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M101,292h-35c-5.51,0-10,4.49-10,10v53.5c0,4.14,3.36,7.5,7.5,7.5h40c4.14,0,7.5-3.36,7.5-7.5',
        'v-53.5c0-5.51-4.49-10-10-10ZM96,307v17h-25v-17h25ZM71,348v-9h25v9h-25Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M407.5,451h40c4.14,0,7.5-3.36,7.5-7.5v-48c0-4.14-3.36-7.5-7.5-7.5h-40c-4.14,0-7.5,3.36-7.5,',
        '7.5v48c0,4.14,3.36,7.5,7.5,7.5ZM415,436v-9h25v9h-25ZM440,403v9h-25v-9h25Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M335.5,451h40c4.14,0,7.5-3.36,7.5-7.5v-48c0-4.14-3.36-7.5-7.5-7.5h-40c-4.14,0-7.5,3.36-7.5,',
        '7.5v48c0,4.14,3.36,7.5,7.5,7.5ZM343,436v-9h25v9h-25ZM368,403v9h-25v-9h25Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M407.5,363h40c4.14,0,7.5-3.36,7.5-7.5v-53.5c0-5.51-4.49-10-10-10h-35c-5.51,0-10,4.49-10,',
        '10v53.5c0,4.14,3.36,7.5,7.5,7.5ZM415,348v-9h25v9h-25ZM440,307v17h-25v-17h25Z',
      ].join('')"
      fill="currentColor"
    />
    <path
      :d="[
        'M335.5,363h40c4.14,0,7.5-3.36,7.5-7.5v-53.5c0-5.51-4.49-10-10-10h-35c-5.51,0-10,4.49-10,',
        '10v53.5c0,4.14,3.36,7.5,7.5,7.5ZM343,348v-9h25v9h-25ZM368,307v17h-25v-17h25Z',
      ].join('')"
      fill="currentColor"
    />
  </svg>
</template>
